export default function IconLabel({ icon: Icon, label }) {
    return (
        <div className='flex flex-row items-center gap-2'>
            <div className='p-2 bg-gray-300 rounded-full'>
                <Icon className='text-white ' />
            </div>
            <span className='text-sm text-gray-700'>
                <i>{label}</i>
            </span>
        </div>
    )
}
